/**
 * Describes the shape of a single action.
 */
export interface IBuyTicketsStateAction {
    type: ActionType;
    value?: any;
}

/**
 * Represents all of the actions that a user can perform on the search page. It's a class so that a dev can extend it.
 */
export class ActionType {

    static get UpdateEventFilter() {
        return "UpdateEventFilter";
    }
    static get EventApiError() {
        return "EventApiError";
    }
    static get RemoveEventFilter() {
        return "RemoveEventFilter";
    }
    static get RemoveAllEventFilters() {
        return "RemoveAllEventFilters";
    }
    static get UpdateEvents() {
        return "UpdateEvents";
    }
    static get UpdateShowPosterInfo() {
        return "UpdateShowPosterInfo";
    }
    static get ChangeProductionSeasonFilter() {
        return "ChangeProductionSeasonFilter";
    }
    static get BrowserNavigated() {
        return "BrowserNavigated";
    }
    static get EventUpdated() {
        return "EventUpdated";
    }
    static get RequestEvents() {
        return "RequestEvents";
    }
    static get RequestBuyTicketsEvents() {
        return "RequestBuyTicketsEvents";
    }
    static get RequestBuyTicketsShowPosterInfo() {
        return "RequestBuyTicketsShowPosterInfo";
    }
    static get UpdateSettings() {
        return "UpdateSettings";
    }
    static get RequestText() {
        return "RequestText";
    }
    static get ReceiveText() {
        return "ReceiveText";
    }
    static get ErrorApiText() {
        return "ErrorApiText";
    }
    static get RequestPromoCodeApply() {
        return "RequstPromoCodeApply";
    }
    static get ReceivePromoCodeApply() {
        return "ReceivePromoCodeApply";
    }
    static get ErrorPromoCodeApply() {
        return "ErrorPromoCodeApply";
    }
    static get SetToMobile() {
        return "SetToMobile";
    }
    static get SetToDesktop() {
        return "SetToDesktop";
    }
    static get UpdatePromoCode() {
        return "UpdatePromoCode";
    }
    static get ImageHasLoaded() {
        return "ImageHasLoaded";
    }
}